import { makeStyles } from "@material-ui/core";
import { theme } from "../../utils/global";

const useStyles = makeStyles(() => ({
  root: {
    height: "100px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: "0 6em",
    color: "#ffffff",
    '&.bgNavBar': {
      backgroundColor: '#100e17'
    },
    '&.notScrolled':{
    backgroundImage: `linear-gradient(#282437, #282437, #282437)`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: "0 2em",
    }
  },
  navRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: 'flex-end',
  },
  navContent: {
    width: "100%",
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  navPath: {
    fontSize: '1em',
    padding: '7px',
    margin: '0 5px',
    fontWeight: 600,
  },
  downloadCvBtn: {
    marginLeft: 10,
    backgroundColor: '#0854E3',
    color: "#ffffff",
    width: '110px',
    padding: '7px 0',
    borderRadius: 7,
    fontWeight: 600,
  },
  downloadIcon: {
    marginLeft: 5,
    },
   display_picture: {
    display: 'flex',
    width: 55,
    height: 55,
    background: '#E6E7ED',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',

    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'contain',
      maxWidth: '100%',
      borderRadius: '50%',
    },
  },
  smallScreenCvBtn: {
    [theme.breakpoints.up('sm')]:{
      display: 'none'
    }
  }
}))

export {useStyles};
